'use client'

import { PropsWithChildren } from 'react'
import Slider, { Settings } from 'react-slick'

export interface ReactSlickSliderProps extends Settings {
  className?: string
}

export const ReactSlickSlider = ({
  className,
  children,
  ...rest
}: PropsWithChildren<ReactSlickSliderProps>) => {
  return (
    <Slider
      className={className}
      {...rest}
    >
      {children}
    </Slider>
  )
}
